import React, { useState } from "react";
import Navbar from "@/components/Navbar";
import { api, showToast } from "@/lib/api";
import { useAuth } from "@/App";
import { ShareStoryModal, StartTopicModal } from "@/components/Modals";

export default function Contact() {
  const { user, login } = useAuth();
  const [name, setName] = useState(user?.real_name || user?.name || "");
  const [email, setEmail] = useState(user?.email || "");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [topicOpen, setTopicOpen] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    if (!name.trim() || !email.trim() || !phone.trim() || !message.trim()) {
      showToast("Please fill all fields"); return;
    }
    setSubmitting(true);
    try {
      await api.post("/contact", { name: name.trim(), email: email.trim(), phone: phone.trim(), message: message.trim() });
      setDone(true);
      setMessage("");
    } catch (err) {
      showToast(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Navbar onShare={()=>{ if(!user){login();return;} setShareOpen(true); }} onTopic={()=>{ if(!user){login();return;} setTopicOpen(true); }} />
      <div style={{maxWidth:680,margin:"0 auto",padding:"40px 26px"}}>
        <h1 style={{fontFamily:"'Instrument Serif',serif",fontSize:42,lineHeight:1.1,marginBottom:8}}>
          Get in <em style={{color:"#C47E2B"}}>touch</em>
        </h1>
        <p style={{fontSize:15,color:"#6C6C70",lineHeight:1.7,marginBottom:32}}>
          Have feedback, a partnership idea, or a moderation concern? Drop us a note — the LanTen team responds within 1–2 business days.
        </p>

        {done ? (
          <div style={{background:"rgba(42,122,80,.08)",border:"1.5px solid rgba(42,122,80,.3)",borderRadius:14,padding:"30px 26px",textAlign:"center"}}>
            <div style={{fontSize:38,marginBottom:10}}>✅</div>
            <div style={{fontFamily:"'Instrument Serif',serif",fontSize:24,marginBottom:6,color:"#2A7A50"}}>Message received</div>
            <p style={{fontSize:14,color:"#3A3A3C",lineHeight:1.7,marginBottom:18}}>Thanks {name.split(" ")[0]}. We'll get back to you on <strong>{email}</strong>.</p>
            <button data-testid="contact-send-another" className="btn-ghost" onClick={()=>setDone(false)}>Send another message</button>
          </div>
        ) : (
          <form onSubmit={submit} style={{background:"white",border:"1.5px solid #E0DDD6",borderRadius:14,padding:30}}>
            <div className="g2">
              <div className="ff"><label>Name</label>
                <input data-testid="contact-name" value={name} onChange={(e)=>setName(e.target.value)} placeholder="Your full name" />
              </div>
              <div className="ff"><label>Email</label>
                <input data-testid="contact-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="you@example.com" />
              </div>
            </div>
            <div className="ff"><label>Phone Number</label>
              <input data-testid="contact-phone" value={phone} onChange={(e)=>setPhone(e.target.value)} placeholder="+91 98xxx xxxxx" />
            </div>
            <div className="ff"><label>Comments / Message</label>
              <textarea data-testid="contact-message" value={message} onChange={(e)=>setMessage(e.target.value)} style={{minHeight:130}} placeholder="Tell us what's on your mind…" />
            </div>
            <button type="submit" className="btn-full" data-testid="contact-submit-btn" disabled={submitting}>
              {submitting ? "Sending…" : "Send Message →"}
            </button>
          </form>
        )}
      </div>
      <ShareStoryModal open={shareOpen} onClose={()=>setShareOpen(false)} />
      <StartTopicModal open={topicOpen} onClose={()=>setTopicOpen(false)} />
    </div>
  );
}
